// extracted by mini-css-extract-plugin
export default {"verificationButton":"VerificationButton_verificationButton__AsY9d"};